//extracted by mini-css-extract-plugin
export default {"bodyContainer":"styles_bodyContainer__nFQF2","sidePanelContainer":"styles_sidePanelContainer__jj5W9"};;